/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpsertAssetPositionRestrictionOptions,
  UpsertAssetPositionRestrictionResponses,
} from '../types/UpsertAssetPositionRestriction'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Caps the USD value of the position any user may hold open in the given asset, counting available, locked, impending borrow and borrowed balances across the user's global and isolated accounts. The cap is the same for every tenant. A limit of 0 lifts the cap, so there is no delete. A separate limit may be set for trading challenge participants and for everyone else; applied_to_challenges selects which one is written.
 * @summary Set the open position size limit for one asset.
 * {@link /v1/assets/:asset_id/restrictions}
 */
export function upsertAssetPositionRestriction<ThrowOnError extends boolean = true>(
  options: Options<UpsertAssetPositionRestrictionOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpsertAssetPositionRestrictionResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/assets/{asset_id}/restrictions',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpsertAssetPositionRestrictionResponses, ThrowOnError>>,
  )
}
